import { AbilityCan, AbilitySubjects, UserRole } from '../enums';
import type { IAbilityFunction, IAbilityUser } from './abilities.types';

export function defineAbilitiesForLocks(user: IAbilityUser, allow: IAbilityFunction, _forbid: IAbilityFunction) {
    if (user.role === UserRole.ADMIN) {
        allow(AbilityCan.CRUD, AbilitySubjects.LOCK);
    }
}
